import { debounce } from 'throttle-debounce';

export const debouncedAction = (interval) =>
  debounce(interval, (data, actionFn) => actionFn(data));
